/**
 * Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ReportContentDetailComponent } from './report-content-detail/report-content-detail.component';
import { ReportContentTabularComponent } from './report-content-tabular/report-content-tabular.component';
import { ReportContentPrintDetailComponent } from './report-content-detail/report-content-print-detail.component';
import { ReportContentPrintTabularComponent } from './report-content-tabular/report-content-print-tabular.component';
import { ReportContentPdfComponent } from './report-content-pdf/report-content-pdf.component';
import { ReportContentChartComponent } from './report-content-chart/report-content-chart.component';
import { CustomPieChartComponent } from './report-content-chart/custom-pie-chart.component';
import { CustomPieSeriesComponent } from './report-content-chart/custom-pie-series.component';
import { CustomChartComponent } from './report-content-chart/custom-chart.component';
import { ReportContentPendingComponent } from './report-content-pending/report-content-pending.component';
import { ReportFieldsModule } from './fields/report-fields.module';
import { ReportContentContainerComponent } from './report-content-container.component';
import { ReportContentContainerPrintComponent } from './report-content-container-print.component';
import { MomentModule } from 'ngx-moment';
import { ZoomButtonModule } from '../../../core/ui/zoomButton/zoom-button.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ReportContentFilterComponent } from './report-content-filter/report-content-filter.component';
import { CustomBarVerticalComponent } from './report-content-chart/custom-bar-vertical.component';
import { CustomLineChartComponent } from './report-content-chart/custom-line-chart.component';
import { UiModule } from '../../../core/ui/ui.module';


@NgModule({
    declarations: [
        ReportContentContainerComponent,
        ReportContentContainerPrintComponent,
        ReportContentDetailComponent,
        ReportContentTabularComponent,
        ReportContentPrintDetailComponent,
        ReportContentPrintTabularComponent,
        ReportContentPdfComponent,
        ReportContentChartComponent,
        CustomPieChartComponent,
        CustomPieSeriesComponent,
        CustomChartComponent,
        ReportContentPendingComponent,
        ReportContentFilterComponent,
        CustomBarVerticalComponent,
        CustomLineChartComponent,
    ],
    exports: [ReportContentContainerComponent, ReportContentContainerPrintComponent],
    imports: [SharedModule, ReportFieldsModule, ZoomButtonModule, MomentModule, NgxChartsModule, UiModule],
})
export class ReportContentModule {}
